import { bibleConstants } from '../actions/constants/bibleConstants';

const initialBible = {	
	items: [],
	allBibles: [],
	message: '',
	isFilterAndTotalCountDataLoaded: false
};

const bibleData = (state = initialBible, action: any) => {
	switch (action.type) {
		case bibleConstants.BibleGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isListSuccess: false
			};
		case bibleConstants.BibleGetByFilterSuccess:
			if (!state.isFilterAndTotalCountDataLoaded) {
				return {
					...state,
					isLoading: false,
					isSuccess: true,
					isError: false,
					isListSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.bibles : [],
					languages: (action.payload !== "" && action.payload !== null) ? action.payload.languages : [],
					uniqueCodes: (action.payload !== "" && action.payload !== null) ? action.payload.uniqueCodes : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1,
				};
			} else {
				return {
					...state,
					isLoading: false,
					isSuccess: true,
					isError: false,
					isListSuccess: true,
					items: action.payload.bibles,
				};
			}
		case bibleConstants.BibleGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				items:[],
				languages: [],
				uniqueCodes:[],
				status: action.payload
			};
		case bibleConstants.BibleGetDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDetailComplete: false,
			};
		case bibleConstants.BibleGetDetailSuccess:
			return {

				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				biblesInput: action.payload
			};
		case bibleConstants.BibleGetDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case bibleConstants.BibleSaveRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case bibleConstants.BibleSaveSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status
			};
		case bibleConstants.BibleSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case bibleConstants.BibleDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDeleteCompleted: false
			};
		case bibleConstants.BibleDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case bibleConstants.BibleDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: false,
				status: action.payload
			};
		case bibleConstants.BibleGetAllRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isGetAllSuccess: false,
				isListSuccess: false
			};
		case bibleConstants.BibleGetAllSuccess:
				return {
					...state,
					isLoading: false,
					isSuccess: true,
					isError: false,
					isGetAllSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					isListSuccess: false,
					allBibles: (action.payload !== "" && action.payload !== null) ? action.payload.bibles : []
				};
		case bibleConstants.BibleGetAllFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isListSuccess:false,
				isError: true,
				isGetAllSuccess: true,
				allBibles: [],
				status: action.payload
			};

		case bibleConstants.BibleTranslationSearchRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			}
		case bibleConstants.BibleTranslationSearchSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isSearch:true,
				readingText:action.payload
			}
		case bibleConstants.BibleTranslationSearchFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
			}

		default:
			return state;
	}
};

export default bibleData;
